import { Tooltip, InfoIcon, cn } from '@aleph/shared-components';
import { GroupAssetFormat } from 'wb-spotify/graphql/generated';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';

interface IProps {
	field: 'adCompanionAsset' | 'adLogoAsset' | 'adCanvasAsset' | 'adAsset';
	groupFormat?: GroupAssetFormat;
	className?: string;
}

const MediaInfoBubble = ({ field, groupFormat = GroupAssetFormat.Audio, className }: IProps) => {
	const { t } = useTranslation();

	const INFO_TEXTS = useMemo(() => ({
		[GroupAssetFormat.Audio]: {
			adCompanionAsset: t('sp: AudioCompanionFormat', `Format: .JPEG or .PNG
		Minimum size: 600x600 pixels`),
			adLogoAsset: t('sp: AudioCompanionFormat', `Format: .JPEG or .PNG
		Minimum size: 600x600 pixels`),
			adCanvasAsset: t('sp: AudioCanvasFormat', `Format: .JPEG, .PNG, .MOV
		Minimum size: 720 x 1280 pixels
		Loop length: 3-8 seconds`),
			adAsset: t('sp: AudioAssetFormat', `Format: MP3, OGG, or WAV
			Max duration: 30 seconds
			Include VoiceOver
			Music-only ads not supported`),
		},
		[GroupAssetFormat.Video]: {
			adCompanionAsset: t('sp: AudioCompanionFormat', `Format: .JPEG or .PNG
		Minimum size: 600x600 pixels`),
			adLogoAsset: t('sp: AudioCompanionFormat', `Format: .JPEG or .PNG
		Minimum size: 600x600 pixels`),
			adCanvasAsset: '',
			adAsset:       t('sp: VideoAssetFormat', `Format: .MOV, .MP4
			Max duration: 30 seconds
			Include VoiceOver
			Music only ads not supported`),
		},
		[GroupAssetFormat.Image]: {
			adCompanionAsset: t('sp: ImageAssetFormat', `Format: .JPEG or .PNG
		Minimum size: 600x500 pixels`),
			adLogoAsset: t('sp: AudioCompanionFormat', `Format: .JPEG or .PNG
		Minimum size: 600x600 pixels`),
			adCanvasAsset: '',
			adAsset:       t('sp: AudioCompanionFormat', `Format: .JPEG or .PNG
		Minimum size: 600x600 pixels`),
		},
	}), [t]);

	return (
		INFO_TEXTS[groupFormat][field] ? (<Tooltip
			placement="top-start"
			content={INFO_TEXTS[groupFormat][field]}
			className="z-50 whitespace-pre-line"
			showArrow
		>
			<InfoIcon className={cn('w-[16px] h-[16px]', className)} />
		</Tooltip>) : null
	);
};

export default MediaInfoBubble;
